<template>
  <div v-if="total_page" class="d-flex flex-row flex-wrap gap-2 justify-content-between align-items-center w-100" style="padding: 1.5rem;">
    <div class="d-flex flex-row flex-wrap gap-2 justify-content-start align-items-center w-50">
      <button
        type="button"
        @click="page > 1 ? changePage(page - 1) : null" class="btn-pagination"
      >
        <font-awesome-icon icon="fa-solid fa-chevron-left" />
      </button>

      <button
        v-for="(index) in getNumber()"
        :key="index" type="button"
        @click="index != '...' ? changePage(index) : pass"
        :class="getClassesNumber(index)"
      >
        {{ index }}
      </button>

      <button
        type="button"
        @click="page < total_page ? changePage(page + 1) : null"
        class="btn-pagination"
      >
        <font-awesome-icon icon="fa-solid fa-chevron-right" />
      </button>
    </div>
    <div class="row g-3 align-items-center w-50 justify-content-end">
      <div class="col-auto">
        <label for="show" class="col-form-label">Show</label>
      </div>
      <div class="col-7 col-sm-7 col-md-5 col-lg-3">
        <select-form id="show" @change="changeLimit()" v-model="show"
          :options="getShowList([1, 2, 5, 10, 20, 50, 100])" />
      </div>
    </div>
    <div class="form-group">
    </div>
  </div>
</template>

<style scoped>
.btn-number {
  box-shadow: none;
}

.btn-number:hover {
  box-shadow: none !important;
}
</style>

<script>
import SelectForm from './SelectForm.vue';
export default {
  components: { SelectForm },
  name: "argon-pagination",
  props: {
    page: Number,
    total_page: {
      type: Number,
      // default: 1,
    },
    current_page: Number,
    color: String,
    size: [Number, String],
  },
  data() {
    return {
      show: 10,
    }
  },
  watch: {

  },
  methods: {
    indexOfNestedArray(arr, target) {
      for (let i = 0; i < arr.length; i++) {
        const element = arr[i];

        if (Array.isArray(element)) {
          const index = this.indexOfNestedArray(element, target);

          if (index !== -1) {
            return [i, ...index];
          }
        } else if (element === target) {
          return [i];
        }
      }

      return -1;
    },
    getNumber() {
      const array = Array.from({ length: this.total_page }, (_, i) => i + 1);  // Membuat array dari 1 hingga 100
      const groupedArray = [];

      for (let i = 0; i < array.length; i += 4) {
        const group = array.slice(i, i + 4);  // Mengambil 4 elemen dari array
        groupedArray.push(group);
      }

      // Mencetak kelompok-kelompok array
      let data = [];
      groupedArray.forEach((group) => {
        data.push(group);
      });
      let display = data?.[this.indexOfNestedArray(data, this.current_page)[0]] ?? [];
      if (display[0] != 1) {
        display.unshift('...')
        display.unshift(1)
      }
      if (display[display.length - 1] != this.total_page) {
        display.push('...')
        display.push(this.total_page)
      }
      // console.log(display)
      return display;
    },
    getShowList(list) {
      let showlist = [];
      list.forEach((element) => {
        showlist.push({ text: [element, "rows"].join(" "), value: element });
      });
      return showlist;
    },
    changeLimit() {
      this.$emit("changelimit", this.show);
    },
    getClassesNumber(index) {
      return {
        'btn-pagination': true,
        'btn-pagination--active': this.page == index,
        // 'btn-number': true,
        // 'rounded-circle': true,
        // 'active': true,
      }
    },
    changePage(cpage) {
      this.$emit("changepage", cpage);
    },
    getClasses: (color, size) => {
      let colorValue, sizeValue;

      colorValue = color ? `pagination-${color}` : null;
      sizeValue = size ? `pagination-${size}` : null;

      return `${colorValue} ${sizeValue}`;
    },
  },
};
</script>
